import { TYPE, rootContainer } from "../../../services/container/root";
import { IIframeService } from "../../../services/iframe-service/iframe-service";

export const MANAGE_RETURNS_PARENT_PATH = "/dashboard/returns";

export const buildManageReturnsParentUrl = (): string => {
    const params = new URLSearchParams();

    try {
        if (window.top && window.top !== window) {
            new URLSearchParams(window.top.location.search).forEach((value, key) => {
                params.set(key, value);
            });
        }
    } catch {
    }

    // Sidebar "Manage Returns" should open the list, not reopen the current RMA detail.
    params.delete("rmaid");

    if (!params.has("filter_status")) {
        params.set("filter_status", "open");
    }

    return `${MANAGE_RETURNS_PARENT_PATH}?${params.toString()}`;
};

/**
 * Navigates the Laravel parent to Manage Returns instead of routing inside the SPA, so the
 * sidebar behaves exactly like the Laravel one: the parent URL carries `filter_status=open`
 * (the list reads its filters from the parent query string) and ManageReturnsPageController
 * picks the design from the stored preference on load.
 */
export const reloadManageReturnsParent = (): void => {
    const iframeService = rootContainer.get<IIframeService>(TYPE.IframService);
    const targetUrl = buildManageReturnsParentUrl();

    try {
        if (window.top && window.top !== window) {
            window.top.location.assign(targetUrl);
            return;
        }
    } catch (error) {
        console.warn("[ManageReturnsParentNavigation] direct parent navigation failed", error);
    }

    void iframeService.redirectParentFrame(targetUrl).catch(() => {
        iframeService.refreshParentFrame();
    });
};
